import { Component, Input, OnChanges } from '@angular/core';
import { Icomment } from '../../model/Icomment';


@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnChanges {

  @Input() listOfStringComments?: any[];
  public listOfComments: Icomment[]=[];

  ngOnChanges(): void {
    // Newest first. Works on a copy because the input array is owned by the parent.
    this.listOfComments = [...(this.listOfStringComments ?? [])]
      .reverse()
      .map(comm => new Icomment(comm.text,comm.date,comm.author));
  }
}
